export default "__VITE_ASSET__CzRUhk1n__"